"use client";
import dynamic from "next/dynamic";
// Client bridge: Footer.tsx is a server component and `ssr: false` dynamics
// must live in a client file — that's this wrapper's whole job.
const FooterSpotifySimple = dynamic(
  () => import("@/components/Footer/FooterSpotifySimple"),
  { ssr: false }
);
const FooterSpotify = () => {
  return <FooterSpotifySimple />;
};

FooterSpotify.displayName = "FooterSpotify";

export default FooterSpotify;
